import React, { useState, useEffect, useRef } from "react";
import Aotucomplte from "../Aotucomplte";
import axios from "axios";

import TextField from "@material-ui/core/TextField";
import LoadingMain from "../../Loading/Loading";
import Answer from "./Answer";
import ChoseWordLang from "../ChoseWordLang";
import { ButtonGroup, Button } from "react-bootstrap";
import classnames from "classnames";
import iconError from "../../../assets/img/perlingo-buttonn.gif";
import { useDispatch, useSelector } from "react-redux";
import { setTitle, setValidation } from "../../../redux/action/user";
import SelectWord from "../BlankSingle/QuestionBlankChoice";
import { BaseUrl } from "../../../Constant/Config";
import { useHistory } from "react-router";
import { setEditOption, setEditTitle } from "../../../redux/action/Edit";
import {
  setCorrectAnswer,
} from "../../../redux/action/user";
//  Answer
import BlankAnswer from "./TestAnswerBlank"




const BlanckSingleChoise = (props) => {
  const history = useHistory();
  const user = useSelector((state) => state.user);
  const EditState = useSelector((state) => state.Edit);
  const dispatch = useDispatch();
  const [blankFromApi, setBlankFromApi] = useState();
  const [addAnswer, setAddAnswer] = useState([
    <Answer callValue={1} testClick={() => addAnswerHandler()} />,
  ]);
  const [selectedWord, setSelectedWord] = useState([]);
  const [callValue, setCallValue] = useState(1);
  const [loadingModal, setLoadingModal] = useState(false);
  const [onChangeHeader, setonChangeHeader] = useState(EditState.edit && EditState.title ? EditState.title : "");
  const [value, setValue] = React.useState("female");
  const [wordList, setWordList] = useState([]);
  const [chooseLang, setChooseLang] = useState();
  // const [langFa, setLangefa] = useState();
  // const [langEng, setLangEng] = useState();
  const [titlef, setTitlef] = useState("");
  // const handleChange = (event) => {
  //   setValue(event.target.value);
  // };

  ////////////////////////////////// Answer
  const [answerArray, setAnswerArray] = useState(EditState.edit && EditState.option ? EditState.option : [{ title: "", id: 1, correct: false }])
  const AddAnswer = () => {
    let PreviousItem = answerArray[answerArray.length - 1]
    setAnswerArray(answerArray => [...answerArray, { title: "", id: PreviousItem ? PreviousItem.id + 1 : 1, correct: false }])
    dispatch(setCorrectAnswer(answerArray));
  }
  const DeleteAnswer = (title, id) => {
    if (EditState.edit) {
      if (answerArray.length > 1) {
        let ArrayAfterDelete = answerArray.filter(Answer => Answer._id !== id)
        setAnswerArray(ArrayAfterDelete)
      }
    } else {
      if (answerArray.length > 1) {
        let ArrayAfterDelete = answerArray.filter(Answer => Answer.id !== id)
        setAnswerArray(ArrayAfterDelete)
      }
    }

  }

  useEffect(() => {
    dispatch(setCorrectAnswer(answerArray));
    EditState.edit && dispatch(setEditOption(answerArray));

  }, [answerArray])












  let test;
  const addAnswerHandler = (value) => {
    setCallValue(callValue + 1);
    setAddAnswer([...addAnswer, test]);
    EditState.edit && dispatch(setEditOption([...EditState.option, { title: "", correct: false }]))
  };
  console.log(addAnswer, "addAnsweraddAnsweraddAnsweraddAnswer")

  const deleteaddAnswerHandler = (e) => {
    console.log("5")
    EditState.edit && EditState.option && EditState.option.splice(e, 1)
    setAddAnswer(addAnswer.splice(e, 1));

    setAddAnswer([...addAnswer]);
  };

  const getWordList = () => {
    axios
      .get(
        `${BaseUrl}/admin/word/list?api_token=${localStorage.getItem("token")}`
      )
      .then((res) => {
        setWordList(res.data.data);
      })
      .catch((error) => {
        return error.response.data.status === 401
          ? history.push("/login")
          : null;
      });
  };

  // function

  const handletitle = (e) => {
    dispatch(setTitle(e.target.value));
    setTitlef(e.target.value);
  };

  useEffect(() => {
    getWordList();
  }, []);
  const handleChooseLang = (chooseLang) => {
    setChooseLang(chooseLang);
  };

  // useEffect(() => {
  //   if (chooseLang === "fa") {
  //     setBlankFromApi(langFa);
  //   } else {
  //     setBlankFromApi(langEng);
  //   }
  // }, [chooseLang, langFa, langEng]);

  const handleChangeHeader = (e, value) => {
    dispatch(setTitle(e.target.value));
    EditState.edit && dispatch(setEditTitle(e.target.value));
    setonChangeHeader(e.target.value);
  };
  const errorModalBlank = user.correctAnswer.filter(
    (item) => item.correct === true
  );
  console.log(answerArray, "answerArray")
  return (
    <>
      {loadingModal ? <LoadingMain /> : null}
      <div className="col-12  blank-main">
        <div className="col-12 text-right header-type">
          <TextField
            variant="filled"
            id="standard-basic "
            value={onChangeHeader}
            label={<p>عنوان سوال</p>}
            onChange={handleChangeHeader}
            autoComplete="off"
          />
          {user.validation ? <div className="col-12 "></div> : null}
        </div>
        <div className="d-block col-12 my-5 text-right  d-md-flex justify-content-between align-items-center p-0 ">
          <p className="m-0">
            کلمات مورد نظر رو به ترتیب برای عنوان سوال انتخاب کنید و جای خالی رو
            مشخص کنید
          </p>
          {/* <div className="lang-main-question  text-right">
            <ButtonGroup>
              <Button
                onClick={() => handleChooseLang("fa")}
                className={classnames(chooseLang === "fa" ? "active-lang" : "")}
              >
                {" "}
                Fa
              </Button>
              <Button
                onClick={() => handleChooseLang("en")}
                className={classnames(chooseLang === "en" ? "active-lang" : "")}
              >
                {" "}
                En
              </Button>
            </ButtonGroup>
          </div> */}
          <ChoseWordLang />
        </div>
        <div className="col-12 p-0 aotu-blank-content mb-5">
          <SelectWord
            setWordList={setSelectedWord}
            Words={user.WordList}
            selectedWord={selectedWord}
            setSelectedWord={setSelectedWord}
            type="blanck-choies"
          />
        </div>

        <div className="col-12  box-answer mt-3">
          <div className=" text-right col-6">
            <p>پاسخ های خود را وارد کنید و گزینه درست را انتخاب کنید </p>
          </div>
          <div className="add-div-answer col-md-6">
            {
              answerArray &&
              answerArray.map((item, index) => {
                return (
                  <BlankAnswer
                    title={item.title}
                    index={index}
                    correct={item.correct}
                    answerArray={answerArray}
                    setAnswerArray={setAnswerArray}
                    DeleteAnswer={DeleteAnswer}
                    id={EditState.edit ? item._id : item.id}
                  />
                )
              })
            }
            {
              answerArray.length < 4 &&
              <div className="col-12">
                <div className="d-flex justify-content-center align-items-center">
                  <div
                    className="border w-75 py-2 text-center rounded mb-3 pointer"
                    onClick={AddAnswer}
                  >
                    <span className="w-100 text_bold ">افزودن پاسخ جدید +</span>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
        {errorModalBlank.length === 0 ? (
          <div className="style-text" style={{ top: "100%" }}>
            <div className="style-gif float-left ">
              {" "}
              <img src={iconError} alt={iconError} />
            </div>
            <p> لطفا یکی از گزینه هارا انتخاب کنید</p>
          </div>
        ) : (
          ""
        )}
      </div>
    </>
  );
};

export default BlanckSingleChoise;
// {EditState.edit && EditState.option ? EditState.option.map((item, index) => {
//   return (
//     <Answer
//       addAnswer={addAnswer}
//       callValue={callValue}
//       testClick={() =>
//         EditState.option.length > 3 ? null : addAnswerHandler()
//       }
//       onSelected={`callValue 1`}
//       index={index + 1}
//       valueoption={item}
//       value={addAnswer}
//       deleteIcon={() =>
//         EditState.option.length < 1 ? null : deleteaddAnswerHandler(index)
//       }
//     />
//   )
// })
//   :
//   addAnswer.map((item, index) => {
//     console.log(addAnswer, "addAnswer")
//     return (
//       <Answer
//         addAnswer={addAnswer}
//         callValue={callValue}
//         testClick={() =>
//           addAnswer.length > 3 ? null : addAnswerHandler()
//         }
//         onSelected={`callValue 1`}
//         index={index + 1}
//         value={addAnswer}
//         deleteIcon={() =>
//           addAnswer.length < 2 ? null : deleteaddAnswerHandler(index)
//         }
//       />
//     );
//   })}

// {EditState.option.length > 3 ? null : (
//   <button
//     className="add-class-style-button-add"
//     type="botton"
//     onClick={(item) => {
//       return EditState.option.length > 4
//         ? null
//         : addAnswerHandler(callValue);
//     }}
//   >
//     <span>+</span> افزودن پاسخ جدید
//   </button>
// )}